import { Alert, Button, Card, Col, Form, Input, Row, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { fullWidthStyle, titleStyle } from "../constants/style";
import { useContext, useState } from "react";
import { SubmitStatus } from "../api/work-order-api";
import ApiContext from "../api/context";
import Paragraph from "antd/es/typography/Paragraph";
import Link from "antd/es/typography/Link";
import { useNavigate } from "react-router-dom";

export default function () {
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const { api } = useContext(ApiContext);
  const navigate = useNavigate();
  const hasValidEmailAddress = emailAddress.trim() !== "";
  const isSubmitting = submitStatus === SubmitStatus.Submitting;
  const hasFailed = submitStatus === SubmitStatus.Failed;
  const isDone = hasFailed || submitStatus == SubmitStatus.Submitted;
  const canSubmit = !isDone && !isSubmitting && hasValidEmailAddress;

  return (
    <div style={{ position: "fixed", width: "100%", height: "100vh" }}>
      <Title />
      <Row justify="center">
        <Col style={{ width: "325px" }}>
          <Card>
            <Spin spinning={isSubmitting}>
              <Title style={titleStyle} level={4}>
                Password Reset
              </Title>
              <Form
                title="Password Reset"
                name="password-reset"
                layout="vertical"
                colon={false}>
                <Form.Item label="Email Address">
                  <Input
                    placeholder="Enter your email address"
                    disabled={isSubmitting}
                    onChange={e => setEmailAddress(e.target.value)}
                  />
                </Form.Item>
                <Row style={fullWidthStyle} justify="space-between" align="middle">
                  <Link onClick={() => {
                    navigate("/login");
                  }}>Login</Link>
                  <Button
                    type="primary"
                    disabled={!canSubmit}
                    onClick={() => {
                      setSubmitStatus(SubmitStatus.Submitting);
                      api?.postPasswordReset(emailAddress).then(loginResponse => {
                        const isGood = loginResponse.good();
                        if (!isGood) {
                          setSubmitStatus(SubmitStatus.Failed);
                          return;
                        }

                        // Store the token here somewhere.
                        setSubmitStatus(SubmitStatus.Submitted);
                      }).catch(() => {
                        setSubmitStatus(SubmitStatus.Failed);
                      });
                    }}>
                    Submit
                  </Button>
                </Row>
              </Form>
            </Spin>
          </Card>
          {
            submitStatus !== SubmitStatus.Failed ? undefined :
              <>
                <Paragraph />
                <Alert
                  type="error"
                  message="The password reset request has failed." />
              </>
          }
          {
            submitStatus !== SubmitStatus.Submitted ? undefined :
              <>
                <Paragraph />
                <Alert
                  type="info"
                  message="If an account with the email address provided exists, then a password reset link will be sent to that email address." />
              </>
          }
        </Col>
      </Row>
    </div >
  );
}